module.exports = __webpack_public_path__ + "static/media/save.7206d55c.svg";